import React, { useEffect, useRef, useState } from "react";
import createGlobe from "cobe";


const toAngles = (lat, lng) => [Math.PI - ((lng * Math.PI) / 180 - Math.PI / 2), (lat * Math.PI) / 180];


const wrapAngle = (d) => {
  const t = Math.PI * 2;
  const v = ((d % t) + t) % t;
  return v > Math.PI ? v - t : v;
};


const Globe = ({ points, active, reduceMotion }) => {
  const canvas = useRef(null);
  const first = points[0] || [20, 78];
  const target = useRef(toAngles(first[0], first[1]));
  const [ready, setReady] = useState(false);
  const key = JSON.stringify(points);

  // where the globe should be looking
  useEffect(() => {
    const p = points[active] || points[0];
    if (p) target.current = toAngles(p[0], p[1]);
  }, [points, active]);

  useEffect(() => {
    const el = canvas.current;
    if (!el) return undefined;

    let phi = target.current[0];
    let theta = target.current[1];
    let size = Math.max(el.offsetWidth || 0, 280);
    const onResize = () => {
      size = Math.max(el.offsetWidth || 0, 280);
    };
    window.addEventListener("resize", onResize);

    const globe = createGlobe(el, {
      devicePixelRatio: 2,
      width: size * 2,
      height: size * 2,
      phi,
      theta,
      dark: 1,
      diffuse: 1.25,
      mapSamples: 16000,
      mapBrightness: 7,
      baseColor: [0.09, 0.16, 0.21],
      markerColor: [0.37, 0.89, 0.91],
      glowColor: [0.18, 0.5, 0.56],
      markers: points.map(([lat, lng]) => ({ location: [lat, lng], size: 0.05 })),
      onRender: (state) => {
        const [tp, tt] = target.current;
        if (reduceMotion) {
          phi = tp;
          theta = tt;
        } else {
          phi += wrapAngle(tp - phi) * 0.055;
          theta += (tt - theta) * 0.055;
        }
        state.phi = phi;
        state.theta = theta;
        state.width = size * 2;
        state.height = size * 2;
      },
    });
    const t = setTimeout(() => setReady(true), 120);

    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", onResize);
      globe.destroy();
    };
    // eslint-disable-next-line
  }, [key, reduceMotion]);

  return <canvas ref={canvas} className={ready ? "is-ready" : ""} aria-hidden="true" />;
};

export default Globe;